// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=ltr] .summary-card[data-v-5069558b] {\n  border-left: 3px solid var(--primary);\n  padding-left: 0.75rem;\n}[dir=rtl] .summary-card[data-v-5069558b] {\n  border-right: 3px solid var(--primary);\n  padding-right: 0.75rem;\n}", ""]);
// Exports
module.exports = exports;
